import { SET_VIEW_MODE } from '../actions/set-view-mode';

export default function viewMode(state = 'site', action) {
  switch (action.type) {
    case SET_VIEW_MODE:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/view-mode.js